import { NgModule } from '@angular/core';
import { DeviceInfoStatusComponent } from './device-info-status.component';

@NgModule({
  imports: [DeviceInfoStatusComponent],
  exports: [DeviceInfoStatusComponent]
})
export class DeviceInfoStatusModule {}
